import { useState } from "react";
import { Button, Icon } from "semantic-ui-react";

import { Can } from "components";
import { ACL_ACTIVITIES, ACL_RESOURCES } from "models";
import { DeleteParkingGateCodeModal, ParkingGateCodesTable } from "modules/ParkingGateCodesDashboard/components";
import { AddUpdateParkingGateCodeModal } from "modules/ParkingGateCodesDashboard/components/AddUpdateParkingGateCodeModal";
import "modules/ParkingGateCodesDashboard/ParkingGateCodesDashboard.scss";

import type { ParkingGateCode } from "models";

export const ParkingGateCodesDashboard = () => {
  const [parkingGateCodeIdToDelete, setParkingGateCodeIdToDelete] = useState<number | null>(null);
  const [showAddUpdateParkingGateCodeModal, setShowAddUpdateParkingGateCodeModal] = useState(false);
  const [parkingGateCodeToUpdate, setParkingGateCodeToUpdate] = useState<ParkingGateCode | null>(null);

  const handleShowParkingGateCodeUpdateModal = (parkingGateCode: ParkingGateCode) => {
    setShowAddUpdateParkingGateCodeModal(true);
    setParkingGateCodeToUpdate(parkingGateCode);
  };

  const handleCloseAddUpdateParkingGateCodeModal = () => {
    setShowAddUpdateParkingGateCodeModal(false);
    setParkingGateCodeToUpdate(null);
  };

  return (
    <>
      <div className="ParkingGateCodesDashboard">
        <Can I={ACL_ACTIVITIES.Create} the={ACL_RESOURCES.ParkingGateCode}>
          <div className="toolbar">
            <Button basic icon className="add-btn" onClick={() => setShowAddUpdateParkingGateCodeModal(true)}>
              <Icon className="plus" />
            </Button>
          </div>
        </Can>
        <ParkingGateCodesTable
          onUpdateParkingGateCode={handleShowParkingGateCodeUpdateModal}
          onDeleteParkingGateCode={(id: number) => setParkingGateCodeIdToDelete(id)}
        />
      </div>

      <AddUpdateParkingGateCodeModal
        isOpen={showAddUpdateParkingGateCodeModal}
        parkingGateCode={parkingGateCodeToUpdate}
        onClose={handleCloseAddUpdateParkingGateCodeModal}
      />
      <DeleteParkingGateCodeModal parkingGateCodeId={parkingGateCodeIdToDelete} onResetDeleteParkingGateCodeId={() => setParkingGateCodeIdToDelete(null)} />
    </>
  );
};
